// ref: https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/types/react-router-config/react-router-config-tests.tsx

import { renderRoutes } from 'react-router-config';

import type { RouteConfig, RouteConfigComponentProps } from 'react-router-config';

import homeRoutes from './Home';
import notFoundRoutes from './NotFound';

const Root = ({ route }: RouteConfigComponentProps) => (
    <>
        {/* child routes won't render without this */}
        {renderRoutes(route && route.routes)}
    </>
);

const routes: RouteConfig[] = [
    {
        component: Root,
        routes: [...homeRoutes, ...notFoundRoutes],
    },
];

export default routes;
